module.exports = __webpack_public_path__ + "static/media/aditi.ea1b7e1a.jpeg";